@if (visible) {
  <div class="cookie-bar" role="region" [attr.aria-label]="getTranslate('title')">
    <i class="material-symbols-outlined cookie-bar__icon">cookie</i>

    <p class="cookie-bar__text">
      {{ getTranslate('description') }}
      @if (exists(privacy)) {
        <a [href]="privacy" target="_blank" rel="noopener">{{ getTranslate('privacyPolicyLink') }}</a>
      }
    </p>

    <button type="button"
      class="cookie-bar__close"
      [attr.aria-label]="getTranslate('closeLabel')"
      (click)="accept()">
      <i class="material-symbols-outlined">close</i>
    </button>
  </div>
}
